var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type !== 'svg')?_c('i',{class:_vm._class}):_c('img',{attrs:{"src":_vm.path}})}
var staticRenderFns = []

export { render, staticRenderFns }